module.exports = __webpack_public_path__ + "static/media/simple-burger.8ac4d3d5.jpg";